import PropTypes from 'prop-types';
import React from 'react';
import InputQCForm from 'components/core/forms/InputQCForm';
import DataExplorerPage from 'components/core/data_explorer/DataExplorerPage';
import TransformationParameterForm from 'components/page/process/variableRetrieval/TransformationParameterForm';


/**
 * The form that renders details for a coordinate system
 */
export default class InputQC extends TransformationParameterForm {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        exploredDatastreams: PropTypes.object,
        siteFacilities: PropTypes.array
    };

    renderTitle = () => {
        return 'Interpreting the Quality of Input Data';
    };

    renderDescription = () => {
        return 'Control how the process will identify missing/bad values in the input data.';
    };

    renderForm = () => {
        return (
            <DataExplorerPage
                process={this.props.process}
                siteFacilities={this.props.siteFacilities}
                exploredDatastreams={this.props.exploredDatastreams}
            >
                <InputQCForm
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    exploredDatastreams={this.props.exploredDatastreams}
                    hasWritePermissions={this.props.hasWritePermissions}
                />
            </DataExplorerPage>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/page/process/variableRetrieval/inputs/InputQC.js